import {
	makeDebugDraw,
	setDebugDrawZoom
} from '../../libs/debugdraw';
import {
	game
} from '../Game';
import {
	Settings
} from '../Settings';

let canvas = document.createElement('canvas');
let ctx = canvas.getContext('2d', {
	alpha: true
});
let hasDebugDrawing = false;
let debugDraw = null;

export const init = () => {
	document.body.appendChild(canvas);
	canvas.style = `
		position:absolute;
		top:0;
		left:0;
		pointer-events: none;
	`;
	debugDraw = makeDebugDraw(ctx, Settings.PTM, Box2D);
	attach();
}

export const attach = () => {
	if(debugDraw) game.world.SetDebugDraw(debugDraw);
}

export const resize = () => {
	canvas.style.width = `${window.innerWidth}px`;
	canvas.style.height = `${window.innerHeight}px`;
	canvas.width = window.innerWidth;
	canvas.height = window.innerHeight;
}

export const update = (cameraX, cameraY) => {
	hasDebugDrawing = true;
	setDebugDrawZoom(game.editor.cameraHolder.scale.x);

	ctx.save();
	ctx.scale(Settings.PTM, Settings.PTM);
	ctx.translate(cameraX, cameraY);
	ctx.lineWidth /= Settings.PTM;

	ctx.fillStyle = 'rgb(255,255,0)';
	game.world.DebugDraw();

	ctx.restore();
};

export const clear = () => {
	if(!hasDebugDrawing) return;
	ctx.clearRect(0, 0, canvas.width, canvas.height);
	hasDebugDrawing = false;
}
